import styled from 'styled-components';
import colors from '../../utils/colors';
import typography from '../../utils/typography';
const { meld, errorRed } = colors;
const { display5, display6, mainCopy, smallCopy } = typography;
export const getTextSizeStyles = (size) => {
    switch (size) {
        case 'main':
            return mainCopy;
        case 'sm':
            return smallCopy;
        case 'md':
            return display6;
        case 'lg':
            return display5;
    }
};
export const StyledText = styled.span.withConfig({
    shouldForwardProp: (prop) => !['size', 'color', 'disabled', 'invalid'].includes(prop),
})(({ size, color, disabled, invalid }) => [
    getTextSizeStyles(size ?? 'main'),
    { color: color ?? 'inherit', margin: 0, padding: 0 },
    disabled && {
        color: meld,
        cursor: 'not-allowed',
    },
    invalid && {
        color: errorRed,
    },
]);
